import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Row, Col, Alert } from 'react-bootstrap';

const DeliveryTimeSelector = ({ show, onHide, onConfirm, orderType = 'delivery' }) => {
  const [selectedTime, setSelectedTime] = useState('');
  const [customTime, setCustomTime] = useState('');
  const [useCustomTime, setUseCustomTime] = useState(false);
  const [predefinedTimes, setPredefinedTimes] = useState([]);

  // Генерируем предустановленные времена доставки
  useEffect(() => {
    const now = new Date();
    const times = [];
    
    // Добавляем время каждые 30 минут начиная с текущего времени + 1 час
    const startTime = new Date(now.getTime() + 60 * 60 * 1000); // +1 час
    const endTime = new Date(now.getTime() + 4 * 60 * 60 * 1000); // +4 часа
    
    let currentTime = new Date(startTime);
    while (currentTime <= endTime) {
      const timeString = currentTime.toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit'
      });
      
      times.push({
        value: timeString,
        label: timeString,
        timestamp: currentTime.getTime()
      });
      
      currentTime = new Date(currentTime.getTime() + 30 * 60 * 1000); // +30 минут
    }
    
    setPredefinedTimes(times);
    
    // Устанавливаем первое время по умолчанию
    if (times.length > 0) {
      setSelectedTime(times[0].value);
    }
  }, []);

  const handleConfirm = () => {
    const deliveryTime = useCustomTime ? customTime : selectedTime;
    if (deliveryTime) {
      onConfirm(deliveryTime);
      onHide();
    }
  };

  const handleCancel = () => {
    setSelectedTime('');
    setCustomTime('');
    setUseCustomTime(false);
    onHide();
  };

  return (
    <Modal show={show} onHide={handleCancel} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title>
          {orderType === 'delivery' ? 'Выберите время доставки' : 'Выберите время готовности'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="info" className="mb-3">
          <strong>Информация:</strong> Минимальное время {orderType === 'delivery' ? 'доставки' : 'готовности'} - 1 час от текущего времени.
        </Alert>

        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Способ выбора времени:</Form.Label>
            <div className="d-flex gap-3">
              <Form.Check
                type="radio"
                id="predefined"
                name="timeType"
                label="Предустановленное время"
                checked={!useCustomTime}
                onChange={() => setUseCustomTime(false)}
              />
              <Form.Check
                type="radio"
                id="custom"
                name="timeType"
                label="Указать время вручную"
                checked={useCustomTime}
                onChange={() => setUseCustomTime(true)}
              />
            </div>
          </Form.Group>

          {!useCustomTime ? (
            <Form.Group className="mb-3">
              <Form.Label>Выберите время:</Form.Label>
              <Row>
                {predefinedTimes.map((time, index) => (
                  <Col key={index} xs={6} sm={4} md={3} className="mb-2">
                    <Form.Check
                      type="radio"
                      id={`time-${index}`}
                      name="predefinedTime"
                      label={time.label}
                      value={time.value}
                      checked={selectedTime === time.value}
                      onChange={(e) => setSelectedTime(e.target.value)}
                    />
                  </Col>
                ))}
              </Row>
            </Form.Group>
          ) : (
            <Form.Group className="mb-3">
              <Form.Label>Укажите время:</Form.Label>
              <Form.Control
                type="time"
                value={customTime}
                onChange={(e) => setCustomTime(e.target.value)}
                placeholder="HH:MM"
              />
              <Form.Text className="text-muted">
                Формат: ЧЧ:ММ (например, 14:30)
              </Form.Text>
            </Form.Group>
          )}

          <div className="mt-3 p-3 bg-light rounded">
            <strong>Выбранное время:</strong> {useCustomTime ? customTime : selectedTime}
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancel}>
          Отмена
        </Button>
        <Button 
          variant="primary" 
          onClick={handleConfirm}
          disabled={!selectedTime && !customTime}
        >
          Подтвердить
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeliveryTimeSelector;
